<template>
  <div class="advertiser-gallery">
    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-400 mb-8">
      <h1 class="text-4xl">
        advertisers galleries
      </h1>
    </div>
    <div class="container mx-auto">
      <div class="gallery-info flex capitalize justify-end mb-5 text-tiny text-gray-500">
        <span class="nr mr-1">{{images.length}} </span>
        <p>Total Photo Galleries</p>
          <div class="flex ml-2" id="viewcontrols">
            <p class="mr-2">View:</p>
            <div @click="show=false" class="gridview lowercase" :class="{ 'text-darkRed': show === false }">grid</div>
            <span class="text-gray-400 px-1">|</span>
            <div @click="show=true" class="listview lowercase" :class="{ 'text-darkRed': show === true }">list</div>
          </div>
      </div>
      <div class="grid-layout" v-if="!show">
        <div class="click grid-cols-1 grid sm:grid-cols-2  md:grid-cols-3 lg:grid-cols-4 gap-6" v-if="ready">
          <template v-for="(image,index) in images">
            <div class="card-gallery">
              <div class="box-img mb-4 px-2">
                <NuxtLink :to="'/advertiser-gallery/photos/'+image.path">
                  <template v-if="index<1">
                    <nuxt-img
                        width="260"
                        height="315"
                        preload
                        format="webp"
                        rel="preload"
                        :src="image.cover? siteURL+'/storage/images/advertiser-gallery/'+image.path+'/cover/'+image.cover:'no_image_album.jpg'"
                        :alt="image.name"
                        class="mx-auto"
                    />
                  </template>
                  <template v-else>
                    <nuxt-img
                        width="260"
                        height="315"
                        format="webp"
                        loading="lazy"
                        :src="image.cover? siteURL+'/storage/images/advertiser-gallery/'+image.path+'/cover/'+image.cover:'no_image_album.jpg'"
                        :alt="image.name"
                        class="mx-auto"
                    />
                  </template>
               </NuxtLink>
              </div>
              <div class="flex flex-col max-w-[260px] mx-auto">
                <div class="list-box">
                  <h2 class="custom-h2 text-center leading-4 mb-2">
                    <a :href="'/advertiser-gallery/photos/'+image.path" class="underline font-medium text-tiny text-gray-600">{{image.name}}</a>
                  </h2>
                  <div class="items text-center text-tiny text-neutral-800">
                    <span class="number">
                      {{image.nr_images}}
                    </span>
                    items
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        </div>
          <div v-if="show" class="click list-layout">
            <div class="flex flex-row flex-wrap">
              <div v-for="(image,index) in images" class="w-full md:w-1/2 flex">
                <div class="box-img md:mb-4 w-2/6 md:w-2/5">
                  <template v-if="index<1">
                    <nuxt-img
                        width="204"
                        height="240"
                        preload
                        format="webp"
                        rel="preload"
                        :src="image.cover? siteURL+'/storage/images/advertiser-gallery/'+image.path+'/cover/'+image.cover:'/no_image_album.jpg'"
                        class="p-2"
                        :alt="image.name"
                    />
                  </template>
                  <template v-else>
                    <nuxt-img
                        width="204"
                        height="240"
                        format="webp"
                        loading="lazy"
                        :src="image.cover? siteURL+'/storage/images/advertiser-gallery/'+image.path+'/cover/'+image.cover:'/no_image_album.jpg'"
                        class="p-2"
                        :alt="image.name"
                    />
                  </template>
                </div>
                <div class="flex flex-col w-4/6 md:w-2/4">
                  <div class="list-box">
                    <h2 class="custom-h2 leading-4 mb-0.5 sm:mb-2.5">
                      <NuxtLink :to="'/advertiser-gallery/photos/'+image.path" class="underline mb-0.5 sm:mb-2.5 font-medium text-tiny text-gray-600">{{image.name}}</NuxtLink>
                    </h2>
                    <div class="items text-tiny text-neutral-800 mb-0.5 sm:mb-3.5">
                  <span class="number">
                    {{image.nr_images}}
                  </span>
                      items
                    </div>
                    <div class="added">
                      Added On:
                      <span class="date">{{image.timestamp}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div v-if="!ready">
          <LoadersSpinner />
        </div>
    </div>
  </div>
</template>
<script setup>
import {http} from "~/utils/http";
import {ref} from 'vue'
import {useSiteURL} from "~/composables/state";
const images = ref([]);
const imgs = ref([]);
const ready = ref(false);
let show = ref(false);
const siteURL = useSiteURL();

const getData = async () => {
  try {
    await http
        .get("/api/advertisers")
        .then((response) => {
          for(let i = response.data.page.length-1; i >= 0; i--){
            images.value.push({
              id: response.data.page[i].id,
              name: response.data.page[i].name,
              path: response.data.page[i].path,
              cover: response.data.page[i].cover_photo? response.data.page[i].cover_photo:'',
              nr_images: response.data.page[i].images.length,
              timestamp: new Intl.DateTimeFormat('default', {    timeZone: 'utc',year:'numeric', month:'short', day:'numeric'}).format(new Date(response.data.page[i].created_at)),
            })
          }
          ready.value = true;
        });
  } catch (e) {
    console.log(e);
  }
}

getData();
</script>
